import React from 'react'
import { useDispatch } from 'react-redux'
import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import LKButton from '../shared/LKButton'
import { actions as LKModalActions } from '../shared/LKModal'
import { createNavigationConfig } from 'loankeeper-common/components'

import { open } from './actions'
import { ACCOUNT_FORM_MODAL } from './constants'

const AccountFormModal = Loadable(() => import('./AccountForm'))

export const createAccountAddNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'abacus',
  text: translateFn('mnu_acc_account_add'),
  identity: ACCOUNT_FORM_MODAL,
  permission: 'ACC_ACCOUNT_OPEN',
  component: AccountFormModal,
}))

export const OpenButton = ({ name, icon, children, onSuccess, disabled }) => {
  const dispatch = useDispatch()

  function handleClick() {
    //@ts-ignore
    dispatch(LKModalActions.open({ name }))
  }

  return (
    <>
      {/** @ts-ignore */}
      <LKButton alias={icon} onClick={handleClick} disabled={disabled}>
        {children}
      </LKButton>
      <AccountFormModal name={name} onSuccess={onSuccess} />
    </>
  )
}

export { open }

export default AccountFormModal
